import PageShell from "./PageShell";
import Testimonials from "../components/landing/Testimonials";

const ReviewsPage = () => (
  <PageShell title="Reviews">
    <Testimonials />
  </PageShell>
);

export default ReviewsPage;
